module.exports = __webpack_public_path__ + "img/horizontal_6_7_8011.4505a727.png";